import PagerItem from './PagerItem';
import deprecationWarning from './utils/deprecationWarning';

export default deprecationWarning.wrapper(PagerItem, '`<PageItem>`', '`<Pager.Item>`');


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/es/PageItem.js
// module id = 1560
// module chunks = 0